/**
 * The last time the server refused something because of a plan limit — shown
 * in the titlebar sync menu until the user dismisses it (owner request
 * 15.09.2026: "the message should show in the titlebar").
 *
 * Fed by services/syncRejections (a refused sync op), records/itemMove (a
 * refused "Move to cloud") and records/itemLocation (the one-time "kept on this
 * device" notice).
 */
import { create } from 'zustand';
import { addSessionEndedListener } from '../services/channelService';
import { quotaCode } from '../services/planQuota';

export const usePlanLimitStore = create((set) => ({
  /** { code, at } | null — code is plan_quota_boards / _documents / _storage */
  lastRefusal: null,
  /**
   * { kind, at } | null — a new board/document was just created on this device
   * because the cloud is full (card C5). Said ONCE per account and kind:
   * silence would look like the item failed to save, and repeating it on every
   * create would be nagging.
   */
  deviceNotice: null,
  noteDeviceItem: (kind) => set({ deviceNotice: { kind, at: Date.now() } }),
  noteRefusal: (error) => {
    const code = quotaCode(error);
    if (code) set({ lastRefusal: { code, at: Date.now() } });
    return code;
  },
  dismiss: () => set({ lastRefusal: null }),
  dismissDeviceNotice: () => set({ deviceNotice: null }),
}));

export const notePlanLimitRefusal = (error) => usePlanLimitStore.getState().noteRefusal(error);
export const notePlanLimitDeviceItem = (kind) => usePlanLimitStore.getState().noteDeviceItem(kind);

addSessionEndedListener(() => usePlanLimitStore.getState().dismiss());
